import React, { useState, useEffect, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { JsonView, darkStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";

const SidePanel = ({ collapseCallback, collapsed, data }) => {
  const [content, setContent] = useState();

  const shouldExpandCallback = useCallback((level, value, field) => {
    return level < 2;
  }, []);

  const onCollapseClick = () => {
    collapseCallback();
  };

  const customDarkStyles = {
    ...darkStyles,
    stringValue: "string",
    numberValue: "number",
    booleanValue: "boolean",
    nullValue: "null",
    key: "key",
    container: "transparent",
  };

  useEffect(() => {
    if (data === undefined || data === null) return;
    setContent(data);
  }, [data]);

  return (
    <div
      className={`absolute z-10 p-6 pb-0 pr-0 transition-margin duration-300 ease-in-out ${
        collapsed ? "ml-[-420px]" : "ml-[0px]"
      }`}
    >
      <div className="rounded-2xl border border-[#21304e] p-6 w-[28rem] h-full bg-qtx-dark">
        <div className="flex align-center justify-between mb-4">
          <p>API Response</p>
          {collapsed && (
            <button onClick={() => onCollapseClick()} title="Open data snippet">
              <FontAwesomeIcon
                icon={faChevronRight}
                style={{
                  fontSize: "1em",
                  verticalAlign: "middle",
                  height: "20px",
                }}
              />
            </button>
          )}
          {!collapsed && (
            <button
              onClick={() => onCollapseClick()}
              title="Close data snippet"
            >
              <FontAwesomeIcon
                icon={faChevronLeft}
                style={{
                  fontSize: "1em",
                  verticalAlign: "middle",
                  height: "20px",
                }}
              />
            </button>
          )}
        </div>
        <div className="json-container p-2 bg-gray-950 rounded-xl h-[78vh] text-sm overflow-scroll">
          <JsonView
            data={content}
            shouldExpandNode={shouldExpandCallback}
            style={customDarkStyles}
          />
        </div>
      </div>
    </div>
  );
};

export default SidePanel;
